export default __webpack_public_path__ + "static/6-hosted-zone-6892c737f020654a9a9c2034b47b9369.png";